import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { reportDWH } from '../../../EsimQrCodeBlockSlice';

const IosCodes = (props) => {
    const [isCopySmdp, setIsCopySmdp] = useState(false);
    const [isCopyAccessCode, setIsCopyAccessCode] = useState(false);

    useEffect(() => {

    }, []);

    return (
        <>
            <div className='seperator'></div>

            <div className='installation' dangerouslySetInnerHTML={{ __html: props.instructionsTextIos }}></div>

            <div className='installation-box'>

                <div className='box-title-wrapper'>
                    <div className='box-title'> קודי הפעלה לקו </div>
                    <div className='box-sub-title'> {props.subscriberNo} </div>
                </div>

                <div className='box-item-wrapper'>
                    <div className='box-item-title'> כתובת SMDP: </div>
                    <button className='box-item-value' onClick={() => copyTextToClipboard(props.smdp, 'smdp')}>
                        <span>{props.smdp}</span>
                        <div className={`copy-message-wrapper ${isCopySmdp ? 'show' : ''}`}>
                            <div className='copy-message'>הטקסט הועתק</div>
                            <div className='triangle-icon'></div>
                        </div>
                    </button>
                </div>

                <div className='box-item-wrapper'>
                    <div className='box-item-title'> קוד הפעלה </div>
                    <button className='box-item-value' onClick={() => copyTextToClipboard(props.accessCode, 'accessCode')}>
                        <span>{props.accessCode}</span>
                        <div className={`copy-message-wrapper ${isCopyAccessCode ? 'show' : ''}`}>
                            <div className='copy-message'>הטקסט הועתק</div>
                            <div className='triangle-icon'></div>
                        </div>
                    </button>
                </div>

            </div>
        </>
    );

    function copyTextToClipboard(textToCopy, paramName) {
        if (!textToCopy) { return; }

        props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'Copy Activation IOS Codes-  Clicked' });

        try {
            navigator.clipboard.writeText(textToCopy);
        } catch (error) { }

        if (paramName == 'smdp') {
            setIsCopySmdp(true);
            setTimeout(() => { setIsCopySmdp(false); }, 3000);
        }
        if (paramName == 'accessCode') {
            setIsCopyAccessCode(true);
            setTimeout(() => { setIsCopyAccessCode(false); }, 3000);
        }
    }

};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
        smdp: state.esimQrCodeBlock.qrCodeDetails.smdp,
        accessCode: state.esimQrCodeBlock.qrCodeDetails.accessCode,
        instructionsTextIos: state.esimQrCodeBlock.esimBlockData.instructionsTextIos,
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(IosCodes);